import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import SwatchOption from './product-options/swatch-option';
import RadioOption from './product-options/radio-option';
import SelectOption from './product-options/select-option';

const VariantSelector = (props) => {
  const { currentVariant, setCurrentVariant, variants, product, option: originalOption } = props;

  const [isFromLastCollection, setIsFromLastCollection] = useState(() => localStorage.getItem('lastVisitedCollection'));

  useEffect(() => {
    if (!variants || variants.length === 0) return;

    if (!currentVariant?.available) {
      const nextAvailable = variants.find((v) => v.available);

      if (nextAvailable && nextAvailable.id !== currentVariant?.id) {
        console.log(`Default variant unavailable. Switching to next available variant: ${nextAvailable.title}`);

        if (typeof setCurrentVariant === 'function') {
          setCurrentVariant(nextAvailable);
        } else {
          const input = document.querySelector(`input[value="${nextAvailable.title}"]`);
          if (input) input.click();
        }
      }
    }
  }, [variants, currentVariant, setCurrentVariant]);

  useEffect(() => {
    const lastCollection = localStorage.getItem('lastVisitedCollection');
    const referrer = document.referrer || '';

    if (!referrer.includes(window.location.origin) || referrer.includes('/admin/')) {
      localStorage.removeItem('lastVisitedCollection');
      setIsFromLastCollection(false);
      return;
    }

    setIsFromLastCollection(lastCollection === 'thinx-last-call-sale');
  }, [currentVariant]);

  const { tags = [] } = product || {};
  const isSaverSet = tags.includes('thinx-set') || tags.includes('tfal-set');

  const { name: optionName } = originalOption;
  let option = originalOption;

  if (isFromLastCollection && Array.isArray(variants)) {
    const colors = [];
    const sizes = [];

    variants.forEach((variant) => {
      const { metafields, selectedOptions = [] } = variant;
      if (metafields?.finalSale !== true) return;

      const colorOpt = selectedOptions.find((o) => o.name === 'Color');
      const sizeOpt = selectedOptions.find((o) => o.name === 'Size');

      if (colorOpt) colors.push(colorOpt.value);
      if (sizeOpt) sizes.push(sizeOpt.value);
    });

    const uniqueColors = [...new Set(colors)];
    const uniqueSizes = [...new Set(sizes)];

    if (optionName === 'Color') {
      option = { ...originalOption, values: uniqueColors };
    } else if (optionName === 'Size') {
      option = { ...originalOption, values: uniqueSizes };
    }
  }

  const optionNameLower = optionName.toLowerCase();

  if (optionNameLower.includes('color') && !isSaverSet) {
    return (
      <SwatchOption
        {...props}
        option={option}
      />
    );
  }

  if (optionNameLower.includes('size')) {
    return (
      <RadioOption
        {...props}
        option={option}
      />
    );
  }

  return (
    <SelectOption
      classes={clsx({ hidden: isSaverSet })}
      {...props}
      option={option}
    />
  );
};

export default VariantSelector;
